import React from 'react';
import { Autocomplete, TextField, FormControl, FormHelperText } from '@mui/material';
import { useSelector } from 'react-redux';

export default function AutocompleteSelector({
    label,
    options,
    value,
    onChange,
    getOptionLabel = (option) => option.label ?? option.name ?? option,
    getOptionKey = (option) => option.id ?? option.name ?? option,
    isOptionEqualToValue = (option, value) => option === value,
    fullWidth = true,
    multiple = false,
    disabled = false,
    disableClearable = false,
    required = false,
    error = false,
    ...rest
}) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    return (
        <FormControl fullWidth={fullWidth} error={error}>
            <Autocomplete
                clearOnEscape
                multiple={multiple}
                disabled={disabled}
                options={options}
                value={value}
                limitTags={1}
                onChange={(event, newValue) => onChange(newValue)}
                getOptionLabel={getOptionLabel}
                getOptionKey={getOptionKey}
                isOptionEqualToValue={isOptionEqualToValue}
                disableClearable={disableClearable}
                noOptionsText={resourceFinal[appLanguage].messages.FILTER_RESULT_EMPTY}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        required={required}
                        error={error}
                    />
                )}
                {...rest}
            />
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
}
